import * as PIXI from "pixi.js";
import {app, events, gameData, loseSound, ticker, winSound} from "../../utils/pixiApp";
import TWEEN from "@tweenjs/tween.js";
import {getDeviceMedia} from "../../utils/sizes";

const stars = [
    {
        position: {
            x: 226,
            y: 94,
            scale: .5
        }
    },
    {
        position: {
            x: 448,
            y: 105,
            scale: 1
        }
    },
    {
        position: {
            x: 512,
            y: 173,
            scale: .7
        }
    },
    {
        position: {
            x: 69,
            y: 280,
            scale: 1
        }
    },
    {
        position: {
            x: 131,
            y: 339,
            scale: .5
        }
    },
    {
        position: {
            x: 135,
            y: 492,
            scale: .5
        }
    },
    {
        position: {
            x: 454,
            y: 433,
            scale: 1
        }
    },
    {
        position: {
            x: 397,
            y: 520,
            scale: .3
        }
    }
]

const gradientFill = new PIXI.FillGradient(0, 0, 273, 0);
const colorStops = ['#FCE28C', '#FFF3DB', '#FCE28C'];
const gradientTopTExtColor = new PIXI.FillGradient(0, 0, 227, 0);
const gradientBottomTExtColor = new PIXI.FillGradient(0, 0, 92, 0);

colorStops.forEach((number, index) =>
{
    const ratio = index / colorStops.length;

    gradientFill.addColorStop(ratio, number);
    gradientTopTExtColor.addColorStop(ratio, number);
    gradientBottomTExtColor.addColorStop(ratio, number);
});

const style = {
    fontFamily: "Rubik, sans-serif",
    // align: "center",
    dropShadow: true,
    dropShadowAngle: 0.7,
    dropShadowColor: "#ba3800",
    fillGradientType: 1,
    fillGradientStops: [.1,.45,.55, 1],
    fontWeight: "bold",
    letterSpacing: 1,
    lineHeight: 10,
    lineJoin: "round",
    miterLimit: 0,
    stroke: "#ba3800",
    strokeThickness: 5,
}

const sizes = {
    web: {
        raysSize: {
            w: 1018,
            h: 1024
        },
        textSize: 30,
        sumTextSize: 120,
        bynTextSize: 44
    },
    mobile: {
        raysSize: {
            w: 364,
            h: 364
        },
        textSize: 16,
        sumTextSize: 64,
        bynTextSize: 24
    }
}

export class Prize extends PIXI.Container {

    constructor(position) {
        super();

        this.mediaScreen = getDeviceMedia(app.screen.width)
        this.mediaSettings = sizes[this.mediaScreen]

        this.textStyle = new PIXI.TextStyle({...style,...{
                dropShadowAngle: 1.5,
                dropShadowDistance: 2,
                fill: '#FFF0D3'
            },
            ...{fontSize: sizes.web.textSize}
        })

        this.sumTextStyle = new PIXI.TextStyle({...style,...{
                style,
                fill: '#FFF0D3'
            },
            ...{fontSize: sizes.web.sumTextSize}
        })

        this.bynTextStyle = new PIXI.TextStyle({...style,...{
                style,
                fill: '#FFF0D3'
            },
            ...{fontSize: sizes.web.bynTextSize}
        })

        this.pos = position
        this.prize = gameData.getGameData('prize')

        this.prize1 = new PIXI.Sprite(PIXI.Texture.from('prize1'))
        this.prize2 = new PIXI.Sprite(PIXI.Texture.from('prize2'))
        this.prize3 = new PIXI.Sprite(PIXI.Texture.from('prize3'))
        this.rays = new PIXI.Sprite(PIXI.Texture.from('prizeRays'))

        this.prize1.position.set(this.pos.width / 2 , this.pos.height / 2)
        this.prize1.anchor.set(.5, .5)
        this.prize1.pivot.set(.5, .5)
        this.prize2.position.set(0,0)
        this.prize2.anchor.set(.5)
        this.prize3.position.set(0,0)
        this.prize3.anchor.set(.5)
        this.rays.position.set(0,0)
        this.rays.anchor.set(.5)
        this.prize1.setSize(this.mediaSettings.raysSize.w, this.mediaSettings.raysSize.h)

        this.prize1.addChild(this.prize2, this.prize3, this.rays)
        this.prize1.scale.set(.5)
        this.prize1.alpha = 0

        this.textContainer = new PIXI.Container()
        this.textContainer.pivot.set(.5,.5)
        this.topText = new PIXI.Text({ text: 'ты выиграл', style: this.textStyle} );
        this.topText.anchor.set(.5)
        this.topText.scale.set(0)
        this.topText.position.set(this.pos.width / 2 , this.pos.height / 2 - 113)
        this.summText = new PIXI.Text({ text: '0,05', style: this.sumTextStyle});
        this.summText.anchor.set(.5)
        // this.summText.pivot.set(.5)
        this.summText.position.set(this.pos.width / 2 , this.pos.height / 2)
        this.summText.scale.set(0)

        this.bottomText = new PIXI.Text({ text: 'BYN', style: this.bynTextStyle });
        this.bottomText.anchor.set(.5)
        this.bottomText.position.set(this.pos.width / 2 , this.pos.height / 2 + 94)
        this.bottomText.scale.set(0)

        this.textContainer.addChild(this.topText, this.bottomText);
        this.textContainer.alpha = 1
        this.starTexture = PIXI.Texture.from('star')
        this.stars = []
        this.time = 0

        stars.forEach((item) => {
            let star = new PIXI.Sprite(this.starTexture);
            star.anchor.set(.5)
            star.setSize(120 * item.position.scale,120 * item.position.scale)
            // star.position.set((this.prize1.position.x / 2) + item.position.x - (120 / 4),  item.position.y + star.height / 2 )
            star.position.set((this.prize1.position.x - this.prize1.width / 3) + item.position.x,  item.position.y + star.height / 2 )
            star.alpha = 0;
            this.stars.push(star)
            this.addChild(star)
        })

        this.addChild(this.prize1, this.textContainer, this.summText)

        events.onGameDataChange(this.onGameDataChange.bind(this))

        this.TWEEN = TWEEN;
        ticker.add((t) => {
            this.TWEEN.update()
            this.raysAnim(t.deltaTime)
        })
    }

    raysAnim(dt) {
        this.time += .03 * dt;
        this.rays.rotation += .005;
        this.stars.forEach((star, idx) => {
            // star.scale.set(Math.sin(this.time + star.scale.x))
            star.scale.set( Math.sin(star.scale.x * 0.01 + (idx * 6 / 10) + this.time) / 2)
        })
    }

    sumAnimate() {
        const sumTextScaleAnim = new this.TWEEN.Tween({scale: 1}).to({scale: 1.2}, 500).onUpdate(obj => {
            this.summText.scale.x = this.summText.scale.y = obj.scale
        }).repeat(3).yoyo(true).onComplete(() => {
        })
        const balancePosition = window.balancePosition;

        const thisScaleAnim = new this.TWEEN.Tween({scale: .5, alpha: 1}).to({scale: 0, alpha: 0}, 500).onUpdate(obj => {
            this.prize1.scale.set(obj.scale)
            this.textContainer.alpha = obj.alpha
            this.stars.forEach((star) => {
                star.alpha = obj.alpha
            })
        }).onComplete(() => {

        })

        const sumTextMoveAnim = new this.TWEEN.Tween({scale: 1, x: this.pos.width / 2, y: this.pos.height / 2}).to({scale: 0, x: balancePosition.x, y: balancePosition.y - 130}, 400).onUpdate((obj) => {
            this.summText.scale.x = this.summText.scale.y = obj.scale
            this.summText.position.set(obj.x, obj.y)
           // this.summText.rotation += 0.02
        }).onStart(() => {
            thisScaleAnim.start()
        }).onComplete(() => {
            events.emitPrizeCompleate()
            gameData.setGameDataByEvent('finishAnimate', true)
        })

        this.stars.forEach((star) => {
            star.alpha = 1
        })
        sumTextScaleAnim.chain(sumTextMoveAnim)
        sumTextScaleAnim.start()
    }

    onGameDataChange(eventArray) {
        if(eventArray === undefined) return
        if(eventArray.indexOf('gameOver') !== -1) {
            if(gameData.getGameData('prize') !== 0) {
                this.sound(true)
                this.summText.text = String(gameData.getGameData('prize')).replace(".",",")
                setTimeout(this.reset.bind(this), 300)
            } else {
                this.sound(false)
                gameData.setGameDataByEvent('finishAnimate', true)
            }
        }
    }

    reset() {
        this.summText.rotation = 0
        this.summText.position.set(this.pos.width / 2 , this.pos.height / 2);

        new this.TWEEN.Tween({scale: 0, prizeScale: 0, alpha: 0}).to({scale: 1,prizeScale: 0.5, alpha: 1}, 400).onUpdate((obj) => {
            this.summText.scale.set(obj.scale)
            this.topText.scale.set(obj.scale)
            this.bottomText.scale.set(obj.scale)
            this.prize1.scale.set(obj.prizeScale)
            this.prize1.alpha = obj.alpha
            this.summText.scale.set(obj.scale)
            this.textContainer.alpha = obj.alpha
        }).onComplete(() => {
            this.sumAnimate();
        }).delay(1000).start()
    }

    sound(prize) {
        if(gameData.getGameData('sound')) {
            if(prize) {
                winSound.play()
            } else {
                loseSound.play()
            }
        }
    }

    setSizes(position, media) {
        this.mediaScreen = media
        this.pos = {
            width: app.screen.width,
            height: position.height
        }
        this.prize1.position.set(this.pos.width / 2  , this.pos.height / 2)
        this.prize1.setSize(this.mediaSettings.raysSize.w, this.mediaSettings.raysSize.h)
        this.topText.position.set(this.pos.width / 2 , this.pos.height / 2 - 113)
        this.summText.position.set(this.pos.width / 2 , this.pos.height / 2)
        this.bottomText.position.set(this.pos.width / 2 , this.pos.height / 2 + 94)
        this.prize1.alpha = 0
        this.stars.forEach((item, idx) => {
            item.position.set((this.prizeContainer.position.x - this.prizeContainer.width / 3) + stars[idx].position.x,  stars[idx].position.y + item.height / 2 )
        })
    }
}